import React, { useRef } from 'react';
import { motion, useMotionTemplate, useMotionValue, useReducedMotion, useSpring } from 'framer-motion';
interface GlassPanelProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * A Liquid-Glass surface: translucent, blurred, with a specular highlight that
 * tracks the pointer so the panel reads as a physical piece of glass.
 */
export function GlassPanel({
  children,
  className = ''
}: GlassPanelProps) {
  const ref = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  const x = useMotionValue(50);
  const y = useMotionValue(0);
  const sx = useSpring(x, {
    stiffness: 140,
    damping: 22,
    mass: 0.9
  });
  const sy = useSpring(y, {
    stiffness: 140,
    damping: 22,
    mass: 0.9
  });
  const specular = useMotionTemplate`radial-gradient(560px circle at ${sx}% ${sy}%, rgba(255,255,255,0.13), rgba(255,255,255,0.03) 42%, transparent 68%)`;
  const handlePointerMove = (event: React.PointerEvent<HTMLDivElement>) => {
    const node = ref.current;
    if (!node) return;
    const rect = node.getBoundingClientRect();
    x.set((event.clientX - rect.left) / rect.width * 100);
    y.set((event.clientY - rect.top) / rect.height * 100);
  };
  const handlePointerLeave = () => {
    x.set(50);
    y.set(0);
  };
  return <div ref={ref} onPointerMove={reduce ? undefined : handlePointerMove} onPointerLeave={reduce ? undefined : handlePointerLeave} className={`glass-edge relative overflow-hidden rounded-xl border border-white/10 bg-white/[0.045] backdrop-blur-2xl ${className}`} data-id="element-1" data-mp="ypja8gjcm1o6">
      <motion.div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      backgroundImage: reduce ? undefined : specular
    }} data-id="element-2" data-mp="azf8yftmue0c" />
      <div className="relative" data-id="element-3" data-mp="kq0dskzwgerp">{children}</div>
    </div>;
}